import Header from "./components/Header/Header";
//import Video from "./components/Video/Video";
//import About from "./components/About/About";
//import Event from "./components/Event/Event";
//import Speaker from "./components/Speaker/Speaker";
//import News from "./components/News/News";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import Sponsorship from "./components/Sponsorship/Sponsorship";
import Members from "./components/Members/Members";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import MemberProfile from "./components/Members/MemberProfile/MemberProfile.jsx";
import { Routes, Route } from "react-router-dom";
import './App.css'
import NewsBlog from "./components/News&Blog/News&Blog.jsx";
import HeaderMobile from "./components/Header/HeaderMobile/HeaderMobile";



function App() {
  return (
    <div className="App background-image">
      <Header/>
      <HeaderMobile/>
      <div className="contents_container">
        <Routes>
           <Route path="/" element={<Home />} />
           <Route path="/newsblogs" element={<NewsBlog />} />
           <Route path="/sponsorship" element={<Sponsorship/>} />
           <Route path="/members" element={<Members/>} />
           <Route path="/about" element={<About/>} />
           <Route path="/Contact" element={<Contact/>} />
           <Route path="/Profile/:type/:id" element={<MemberProfile/>} />


        </Routes>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
